<template>
    <div class="geren-box">
        <div class="cntens">
            <div class="top-Name">
                <div class="Tou-xiang-Name">
                    <img class="tupian-img" :src="this.$store.state.LoginStatus.image" alt="">
                    <p class="name_text">{{this.$store.state.LoginStatus.username}}</p>
                </div>
                <div class="sanzhong-ren">
                    <div class="tongtaizhong">
                        <p>0</p>
                        <p>{{$t('geren.dongtai')}}</p>
                    </div>
                    <div class="tongtaizhong">
                        <p>0</p>
                        <p>{{$t('geren.guanzhu')}}</p>
                    </div>
                    <div class="tongtaizhong">
                        <p>0</p>
                        <p>{{$t('geren.fensi')}}</p>
                    </div>
                </div>
            </div>
            <el-tabs v-model="activeName">
                <el-tab-pane :label="$t('geren.el_label1')" name="first">
                    <div class="wo_xinxi">
                        <p>{{$t('geren.new_username')}}</p> <input type="text" v-model="nichengs" :placeholder="$t('geren.new_username_tishi')">
                    </div>
                    <div class="wo_xinxi">
                        <p>{{$t('geren.useName')}}</p> <span>{{this.$store.state.LoginStatus.username}}</span>
                    </div>
                    <div class="Bao_cun" @click="XGnicheng()">{{$t('geren.save')}}</div>
                </el-tab-pane>
                <el-tab-pane :label="$t('geren.el_label2')" name="second">    
                    <div class="wo_mima_xiugai">
                        <p class="tlite-mima">{{$t('geren.LoginPassword')}}</p>
                        <div class="shezhi-mima">
                            {{$t('geren.shezhi_text')}}
                            <span @click="centerDialogVisible = true">{{$t('geren.modify')}}</span>
                        </div>
                    </div>
                    <div class="wo_mima_xiugai">
                        <p class="tlite-mima">{{$t('geren.shiming')}}</p>
                        <div class="shezhi-mima">
                            {{$t('geren.upImg')}}
                            <span @click="Upsmrz = true">{{$t('geren.shangchuan')}}</span>
                        </div>
                    </div>
                    <div class="Tuichu_da">
                        <div class="Tuichu" @click="Lonin_tuichu()">
                            {{$t('geren.tuichu')}}
                       </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <!-- Form -->
        <el-dialog
        :title="$t('geren.form_title_mima')"
        :visible.sync="centerDialogVisible"
        width="27%"
        center>
        <div class="el-tanchuang">
            <div class="JIU-mima">
                <div class="p-mima-text"><p>⁎</p>{{$t('geren.from_jiumima')}}</div>
                <div class="JIU-INPUT">
                    <span class="iconfont icon-mima"></span>
                    <input type="text" v-model="jiuMima" @blur="JiuBlur()">
                    <!-- <span class="iconfont icon-chakanmima1"></span> -->
                </div>
                <p v-show="xg.tes1" class="zihongti">{{$t('geren.from_tishi')}}</p>
            </div>
            <div class="JIU-mima">
                <div class="p-mima-text"><p>⁎</p>{{$t('geren.from_xinmima')}}</div>
                <div class="JIU-INPUT">
                    <span class="iconfont icon-mima"></span>
                    <input type="password" v-model="xinPass" @blur="Xinmima">
                    <!-- <span class="iconfont icon-chakanmima1"></span> -->
                </div>
            </div>
            <div class="JIU-mima">
                <div class="p-mima-text"><p>⁎</p>{{$t('geren.from_confirm_mima')}}</div>
                <div class="JIU-INPUT">
                    <span class="iconfont icon-mima"></span>
                    <input type="password" v-model="erjiMima" @blur="queRen">
                    <!-- <span class="iconfont icon-chakanmima1"></span> -->
                </div>
                <p v-show="xg.tes2" class="zihongti">{{$t('geren.from_tishi2')}}</p>
            </div>
        </div>
        <div class="queren-xiugai" @click="clickXG">{{$t('geren.modifyMima')}}</div>
        </el-dialog>
        <!-- 实名认证 -->
        <el-dialog title="实名认证" :visible.sync="Upsmrz" width="27%" center>
            <div class="renz">
                <img :src="selectedFile1" alt="">
                <input type="file" @change="onFileChangesP">
            </div>
            <div class="renz">
                <img :src="selectedFile2" alt="">
                <input type="file" @change="onFileChanges">
            </div>
            <div class="queren-xiugai" style="width: 40%; margin: 0 auto;" @click="Tijiao()">提交</div>
        </el-dialog>
    </div>
</template>
<script>
    import axios from 'axios';
    export default{ 
        data(){
            return{
                activeName:'first',
                centerDialogVisible:false,//密码
                Upsmrz:false,//上传
                xg:{
                    tes1:false,
                    tes2:false,
                },
                xinPass:'',//新密码
                erjiMima:'',//确认密码
                jiuMima:'',//旧密码
                selectedFile1:require('../../assets/zhengbian.jpg'),//图片路径
                selectedFile2:require('../../assets/fanmian.jpg'),//图片路径
                nichengs:'',//昵称
            }
        },
        methods:{
             //修改昵称
            XGnicheng(){
                if(this.nichengs!==''){
                    const data = {
                        nicheng:this.nichengs,
                        iphone:this.$store.state.LoginStatus.phone,
                    }
                    console.log(data);
                    axios.post('api/index/nicheng',data)
                    .then(response => {
                        // 处理请求成功的响应
                        console.log(response.data);
                        if(response.data.code==1){
                            this.$store.state.LoginStatus.username = response.data.data.username;
                            localStorage.setItem('Kp_state', JSON.stringify(this.$store.state.LoginStatus));
                        }else{
                            this.$message.error('昵称已存在!');
                        }
                        
                    })
                    .catch(error => {
                        // 处理请求失败的错误
                        console.error(error);
                    });
                }else{
                    this.$message.warning('新昵称不能为空！');
                }
                
            },
            //旧密码
            JiuBlur(){
                if(this.jiuMima !== ''){
                    this.xg.tes1 = false;
                }else{
                    this.xg.tes1 = true;
                }
            },
            //新密码
            Xinmima(){
                if(this.xinPass !== ''){
                    this.xg.tes1 = false;
                }else{
                    this.xg.tes1 = true;
                }
            },
            //确认
            queRen(){
                
            },
           
            //修改
            clickXG(){
                //歌曲//111
                const data = {
                    jius:this.jiuMima,
                    phonees:this.$store.state.LoginStatus.phone,
                    passwords:this.erjiMima
                }
                axios.post('api/index/xiugai',data)
                .then(response => {
                    // 处理请求成功的响应
                    console.log(response.data);
                    if(response.data.code==1){
                        this.$message.success('密码修改成功');
                        this.centerDialogVisible=false;//密码
                    }else{
                        this.$message.error('旧密码错误');
                        this.centerDialogVisible=true;//密码
                    }
                    
                })
                .catch(error => {
                    // 处理请求失败的错误
                    console.error(error);
                });
                
            },
            //上传反图片
            onFileChanges(e){
                const file = e.target.files[0];
                const reader = new FileReader();
			    reader.readAsDataURL(file);
                reader.onload = (result)=>{
                    console.log(result);
                    this.selectedFile2 = result.target.result;
			    }   
            },
            //上传正图片
            onFileChangesP(e){
                const file = e.target.files[0];
                const reader = new FileReader();
			    reader.readAsDataURL(file);
                reader.onload = (result)=>{
                    console.log(result);
                    this.selectedFile1 = result.target.result;
			    }   
            },
            //提交
            Tijiao(){
                if(this.selectedFile1!=='img/zhengbian.eaa4f350.jpg'&&this.selectedFile2!=='img/fanmian.b4986638.jpg'){
                    this.Upsmrz = false;
                    this.$message.success('已提交成功，待审核3-5天！');
                }else{
                    this.$message.warning('请选择上传图片！');
                }
                
            },
            //退出登录 删除-记录
            Lonin_tuichu(){
                localStorage.removeItem('Kp_state');
                this.$router.push('/home');
                this.$router.go(0);
                
            }
        }
    }
</script>
<style lang="scss">
    .geren-box{
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        align-items: center;
        .cntens{
            width: 1370px;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 30px;
            .top-Name{
                width: 100%;
                height: 145px;
                border-radius: 15px;
                background-color: var(--Name-ye-background);
                display: flex;
                align-items: center;
                position: relative;
                .Tou-xiang-Name{
                    width: 285px;
                    height: 80px;
                    display: flex;
                    align-items: center;
                    margin-left: 35px;
                    .tupian-img{
                        width: 80px;
                        height: 80px;
                        border-radius: 50px;
                    }
                    .name_text{
                        font-size: var(--buttom-song-tlite-size);
                        color: var(--mingcheng-color);
                        margin-left: 15px;
                    }
                }
                .sanzhong-ren{
                    width: 295px;
                    height: 45px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    position: absolute;
                    right: 100px;
                    .tongtaizhong{
                        text-align: center;
                        p{
                            font-size: 14px; 
                            font-family: YuanTi;
                            font-weight: bold;
                            color: var(--mingcheng-color);
                        }
                    }
                }
            }


        }
    }
    .el-tabs{
        width: 100%;
        margin-top: 20px;
    }
    .el-tabs__item{
        color: var(--mingcheng-color);
    }
    .wo_xinxi{
        width: 550px;
        height: 50px;
        display: flex;
        align-items: center;
        margin-left: 20px;
        p{
            font-size: 13px;
            font-family: YuanTi;
            font-weight: bold;
            color: var(--text-color);
        }
        input{
            outline: none;
            border: none;
            height: 33px;
            padding-left: 20px;
            margin-left: 15px;
            // font-weight: bold;
            font-family: YuanTi;
            color: var(--text-color);
            width:400px;
            background-color: var(--to-zhuce-backround);
            border-radius: 3px;
        }
        span{
            margin-left: 30px;
            color: var(--text-color);
            font-size: 14px;
            font-family: YaunTi;
        }
    }
    .Bao_cun{
        width: 60px;
        height: 30px;
        background-color: var(--Name-ye-background);

        font-size: 14px;
        font-family: YuanTi;
        color: var(--text-color);
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        margin-left: 90px;
        margin-top: 20px;
        transition: 0.2s;
        border-radius: 3px;
    }
    .Bao_cun:hover{
        background-color: rgb(53, 114, 255);
        color: #fff;
        transition: 0.2s;
    }
    .wo_mima_xiugai {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 15px;
        .tlite-mima {
            width: 75px;
            font-size: 14px;
            font-weight: bold;
            font-family: YuanTi;
            color: var(--them-color);
        }
        .shezhi-mima{
            width: 93%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 13px;
            font-family: YuanTi;
            // font-weight: bold;
            border-bottom: solid 1px #e4e4e4;
            height: 60px;
            color: var(--text-color);
            span{
                margin-right: 20px;
                cursor: pointer;
                color: var(--text-color-xiugai);
            }   
        }
    }
    .Tuichu_da{
        width: 100%;
        height: 40px;
        position: relative;
        overflow: hidden;
        margin-top: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .Tuichu{
        width: 200px;
        height: 40px;
        font-size: 14px;
        font-family: YuanTi;
        color: #fff;
        border-radius: 5px;
        background-color: var(--lan-background);
        text-align: center;
        line-height: 40px;
        cursor: pointer;
    }
    .tanchuang-box-mima{
        width: 100%;
        height: 100%;

    }
    .el-dialog--center {
        background-color: var(--el-tanchuang-background);
    }
    .el-dialog__title{
        font-size: 16px;
        font-family: YaunTi;
        color: var(--them-color);
    }
    .el-dialog__body{
        padding: none !important;
    }
    .el-tanchuang{
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .JIU-mima{
            width: 480px;
            display: flex;
            flex-direction: column;
            height: 85px;
            .p-mima-text{
                font-size: 14px;
                font-family: YuanTi;
                font-weight: bold;
                display: flex;
                align-items: center;
                color: var(--text-color);
                p{
                    margin-bottom: 5px;
                    margin-right: 3px;
                    color: #f00;
                }
            }
            .JIU-INPUT {
                width: 100%;
                height: 35px;
                position: relative;
                display: flex;
                align-items: center;
                margin-top: 9px;
                input {
                    width: 93%;
                    height: 100%;
                    padding-left: 35px;
                    background-color: var(--el-input-background);
                    border: solid 1px rgb(46, 46, 46);
                    outline: none;
                    color: var(--them-color);
                    border-radius: 5px;
                }
                input:focus{
                    border: solid 1px var(--text-color-xiugai);
                }
                span:nth-child(1) {
                    position: absolute;
                    left: 10px;
                    font-size:20px;
                }
            
                span:nth-child(3) {
                    position: absolute;
                    right: 16px;
                    font-size: 16px;
                    cursor: pointer;
                }
            }
            .zihongti{
                font-size: var(--nav-text-fsize12);
                    color: var(--tishi-color);
                    margin-top: 2px;
            }
        }
       
    }
    .queren-xiugai{
        width: 100%;
        height: 40px;
        text-align: center;
        line-height: 40px;
        font-weight: bold;
        font-family: YuanTi;
        font-size: 14px;
        cursor: pointer;
        background-color: var(--lan-background);
        color: #fff;
        border-radius: 5px;
        margin-top: 10px;
    }
    // 实名认证
    .renz{
        width: 80%;
        height: 250px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        margin-bottom: 30px;
        position: relative;
        img{
            width: 100%;
            height: 260px;
            object-fit: contain;
        }
        input{
            position: absolute;
            opacity: 0;
            width: 100%;
            height: 100%;
        }
    }
</style>